import { __awaiter, __generator, __read } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { getReferralFromFileLocation } from '@office-start/file-utility';
import { DataSecurityLevel, } from '@office-start/instrumentation-types';
import { logDiagnostic, logError } from '@office-start/telemetry-service';
import { convertRawPageToPageName } from '@office-start/telemetry-utility';
import { sanitizeUrlParameter } from '@office-start/url-parser-utility';
import { logClick } from './operations/logClick';
import { isOfficeRouteItem } from './utilities/isOfficeRouteItem';
var getFeatures = function (launchUrlParams) {
    var frame;
    var left = launchUrlParams.left, top = launchUrlParams.top, width = launchUrlParams.width, height = launchUrlParams.height;
    if (left && top) {
        frame = "left=".concat(left, ",top=").concat(top);
    }
    // Sizing specifications
    if (width && height) {
        frame = (frame ? "".concat(frame, ",") : '') + "width=".concat(width, ",height=").concat(height);
    }
    return frame;
};
var resolveLaunchParams = function (launchUrlParams, defaultLinkTarget) {
    if (defaultLinkTarget === void 0) { defaultLinkTarget = '_blank'; }
    if (!launchUrlParams) {
        return [undefined, defaultLinkTarget, window];
    }
    var linkTarget = launchUrlParams.linkTarget, targetTab = launchUrlParams.targetTab;
    return [
        getFeatures(launchUrlParams),
        linkTarget !== null && linkTarget !== void 0 ? linkTarget : defaultLinkTarget,
        targetTab !== null && targetTab !== void 0 ? targetTab : window,
    ];
};
var getResult = function (openResult, linkTarget) {
    if (openResult === null) {
        return 'OpenNull';
    }
    else if (openResult === undefined) {
        return 'OpenUndefined';
    }
    return linkTarget === '_blank' ? 'NewTab' : 'Inline';
};
var submitFormWithAccessToken = function (document, actionUrl, method, accessToken) {
    document.replaceChild(document.implementation.createHTMLDocument('').documentElement, document.documentElement);
    var form = document.createElement('form');
    form.action = actionUrl;
    form.method = method;
    var tokenInput = document.createElement('input');
    tokenInput.type = 'hidden';
    tokenInput.name = 'access_token';
    tokenInput.value = accessToken;
    form.appendChild(tokenInput);
    document.body.appendChild(form);
    form.submit();
};
var getAccessTokenForFile = function (fileUrl, fileReferral) { return __awaiter(void 0, void 0, void 0, function () {
    var url, accessTokenConsumer, resourceUrl, context, accessToken;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = new URL(fileUrl);
                resourceUrl = "".concat(url.protocol, "//").concat(url.hostname);
                if (fileReferral === "Documents" /* KnownWorkloadReferralNames.OneDrive */) {
                    accessTokenConsumer = 'OneDrive';
                }
                else if (fileReferral === "Sites" /* KnownWorkloadReferralNames.SharePoint */) {
                    accessTokenConsumer = 'SharePoint';
                }
                else {
                    throw new Error("Unsupported file referral for fetching access token: ".concat(fileReferral));
                }
                return [4 /*yield*/, fetchOfficeComponentContext()];
            case 1:
                context = _a.sent();
                return [4 /*yield*/, context.getAccessToken(accessTokenConsumer, true, resourceUrl)];
            case 2:
                accessToken = _a.sent();
                if (accessToken.success) {
                    return [2 /*return*/, accessToken.token];
                }
                else {
                    throw new Error("Failed to get sharepoint access token. Error : ".concat(accessToken.error));
                }
                return [2 /*return*/];
        }
    });
}); };
function isODSPDocument(fileReferral) {
    return (fileReferral === "Documents" /* KnownWorkloadReferralNames.OneDrive */ ||
        fileReferral === "Sites" /* KnownWorkloadReferralNames.SharePoint */);
}
export var defaultLaunchUrl = function (urlOrRoute, launchUrlParams, launchInstrumentationParams, officeRouteParams, useAuthtokenFlow) { return __awaiter(void 0, void 0, void 0, function () {
    var success, result, message, router, openResult, sanitizedUrl, _a, features, target, openWindow, fileReferral, useDefaultFlow, token, e_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                success = false;
                message = 'defaultLaunchUrl';
                // For sway creation in Create page, return if url is falsy
                if (!urlOrRoute) {
                    return [2 /*return*/, { message: message, result: result, success: success }];
                }
                if (!isOfficeRouteItem(urlOrRoute)) return [3 /*break*/, 3];
                return [4 /*yield*/, fetchOfficeComponentContext()];
            case 1:
                router = (_b.sent()).router;
                if (launchInstrumentationParams) {
                    // Current click event generated after the click successfully opens the component.
                    // Override the PageName to the real PageName the click occurring.
                    launchInstrumentationParams.pageName = convertRawPageToPageName(router.getCurrentPageForLogging());
                }
                return [4 /*yield*/, router.navigateTo(urlOrRoute, false /* replace */, officeRouteParams)];
            case 2:
                success = _b.sent();
                result = 'Inline';
                message += ".navigateTo:".concat(success);
                return [3 /*break*/, 11];
            case 3:
                openResult = null;
                sanitizedUrl = sanitizeUrlParameter(urlOrRoute);
                _a = __read(resolveLaunchParams(launchUrlParams), 3), features = _a[0], target = _a[1], openWindow = _a[2];
                fileReferral = getReferralFromFileLocation(sanitizedUrl);
                useDefaultFlow = false;
                if (!(useAuthtokenFlow && fileReferral && isODSPDocument(fileReferral))) return [3 /*break*/, 9];
                openResult = openWindow.open('', target, features);
                if (!(openResult === null)) return [3 /*break*/, 4];
                logError({
                    errorType: 'Launch_Error',
                    eventName: 'AuthTokenFlow_ForFileOpen',
                    message: 'Failed to open window',
                });
                useDefaultFlow = true;
                return [3 /*break*/, 8];
            case 4:
                logDiagnostic({
                    eventName: 'Launch_Url_AuthTokenFlow',
                }, DataSecurityLevel.Enhanced);
                _b.label = 5;
            case 5:
                _b.trys.push([5, 7, , 8]);
                return [4 /*yield*/, getAccessTokenForFile(sanitizedUrl, fileReferral)];
            case 6:
                token = _b.sent();
                submitFormWithAccessToken(openResult.document, sanitizedUrl, 'post', token);
                return [3 /*break*/, 8];
            case 7:
                e_1 = _b.sent();
                logError({
                    errorType: 'Launch_Error',
                    eventName: 'AuthTokenFlow_ForFileOpen',
                    message: e_1.message,
                });
                useDefaultFlow = true;
                return [3 /*break*/, 8];
            case 8: return [3 /*break*/, 10];
            case 9:
                useDefaultFlow = true;
                _b.label = 10;
            case 10:
                if (useDefaultFlow) {
                    openResult = openWindow.open(sanitizedUrl, target, features);
                }
                success = !!openResult;
                message += ".open:".concat(success);
                result = getResult(openResult, target);
                _b.label = 11;
            case 11:
                // Note:  router.navigateTo() can return null for Angular Router's navigate() calls that
                // did not result in a navigation (e.g. same URL with onSameUrlNavigation === 'ignore').
                // (https://github.com/angular/angular/blob/99898f33703e46b7fec81babe83701705519af9e/packages/router/src/router.ts#L602)
                // In that case, we'll skip logging the click event since there was technically no referral.
                if (success !== null) {
                    logClick({
                        launchInstrumentationParams: launchInstrumentationParams,
                        success: success,
                        platform: 'Web',
                    });
                }
                return [2 /*return*/, { message: message, result: result, success: success }];
        }
    });
}); };
//# sourceMappingURL=defaultLaunchUrl.js.map